import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const navItems = [
  { to: '/', label: 'ダッシュボード', section: null },
  { to: '/logs/chat', label: 'チャットログ', section: 'ログ管理' },
  { to: '/chat-messages', label: 'チャットメッセージ', section: 'コンテンツ管理' },
  { to: '/faq', label: 'FAQ一覧', section: 'コンテンツ管理' },
  { to: '/symptoms', label: '症状検索一覧', section: 'コンテンツ管理' },
  { to: '/bulk-upload', label: '一括登録', section: 'コンテンツ管理' },
  { to: '/users', label: 'ユーザー管理', section: 'システム管理' },
];

export const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();

  let currentSection: string | null = null;

  return (
    <aside className="fixed left-0 top-0 flex h-full w-64 flex-col bg-slate-900 text-white">
      <div className="border-b border-slate-700 p-4">
        <h1 className="text-lg font-bold">パロマ チャットボット管理画面</h1>
      </div>

      <nav className="flex-1 overflow-y-auto p-3">
        {navItems.map((item) => {
          const showSection = item.section && item.section !== currentSection;
          if (item.section) currentSection = item.section;
          return (
            <div key={item.to}>
              {showSection && (
                <div className="mb-1 mt-4 px-3 text-xs font-semibold uppercase tracking-wider text-slate-400">
                  {item.section}
                </div>
              )}
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `block rounded-lg px-3 py-2 text-sm ${
                    isActive
                      ? 'bg-blue-600 font-medium text-white'
                      : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                  }`
                }
              >
                {item.label}
              </NavLink>
            </div>
          );
        })}
      </nav>

      <div className="border-t border-slate-700 p-4">
        <div className="mb-2 truncate text-sm text-slate-300">{user?.email}</div>
        <button
          onClick={() => logout()}
          className="w-full rounded-lg px-3 py-2 text-left text-sm text-slate-300 hover:bg-slate-800 hover:text-white"
        >
          ログアウト
        </button>
      </div>
    </aside>
  );
};
